import React from 'react';
import {useSHCore} from '@hooks/useSHCore';
import {getInitialComponentData} from "@helpers/HelperInitialPageState";

const ContextServicesFeaturesTable = React.createContext({});


const ContextServicesFeaturesTableProvider = ({children, contextName}) => {

	const resolvedName = typeof contextName === 'string' ? contextName : 'contextServicesFeaturesTable';
	const providerData = getInitialComponentData(resolvedName);

	const core = useSHCore({
		name: providerData.componentName,
		token: providerData.componentToken,
		initialState: {
			contextData: providerData.componentData,
		},
	});

	return (
	  <ContextServicesFeaturesTable.Provider value={core.state}>
		  {children}
	  </ContextServicesFeaturesTable.Provider>
	);
};

export {ContextServicesFeaturesTable, ContextServicesFeaturesTableProvider};

